// Terminal-PIN im eigenen Konto (Phase 3, docs/DESIGN-zeit-kiosk-terminal.md).
//
// Der Mitarbeiter setzt sie SELBST — mit Passwort-Bestätigung, damit ein unbeaufsichtigt offenes Gerät nicht
// genügt, um sich eine Stempel-Identität einzurichten. Es gibt bewusst keinen Weg, auf dem der Chef eine PIN
// setzt oder liest: genau diese Asymmetrie macht den Stempel am geteilten Terminal beweiskräftig.
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { api } from '../api/client'

export function PinCard(): React.JSX.Element {
  const [pin, setPin] = useState('')
  const [repeat, setRepeat] = useState('')
  const [password, setPassword] = useState('')
  const [done, setDone] = useState(false)

  const save = useMutation({
    mutationFn: () => api.setMyPin(pin, password),
    onSuccess: () => {
      setDone(true)
      setPin(''); setRepeat(''); setPassword('')
    },
  })

  const mismatch = repeat.length > 0 && pin !== repeat
  const valid = /^[0-9]{6}$/.test(pin) && pin === repeat && password.length > 0

  return (
    <section className="card">
      <h3>Terminal-PIN</h3>
      <p className="muted">
        Mit dieser sechsstelligen PIN stempelst du am Werkstatt-Tablet, ohne dich anzumelden. Sie ist dein
        persönliches Geheimnis — niemand im Betrieb kann sie einsehen, auch der Chef nicht. Er kann sie nur
        zurücksetzen; dann vergibst du hier eine neue.
      </p>

      <label className="wf-field">
        <span>Neue PIN (6 Ziffern)</span>
        <input
          className="wf-input"
          type="password"
          inputMode="numeric"
          autoComplete="new-password"
          value={pin}
          onChange={(e) => { setPin(e.target.value.replace(/\D/g, '').slice(0, 6)); setDone(false) }}
        />
      </label>
      <label className="wf-field">
        <span>PIN wiederholen</span>
        <input
          className="wf-input"
          type="password"
          inputMode="numeric"
          autoComplete="new-password"
          value={repeat}
          onChange={(e) => setRepeat(e.target.value.replace(/\D/g, '').slice(0, 6))}
        />
      </label>
      <label className="wf-field">
        <span>Zur Sicherheit: dein Passwort</span>
        <input className="wf-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
      </label>

      {mismatch && <p className="wf-error">Die beiden PINs stimmen nicht überein.</p>}
      {save.isError && <p className="wf-error">{(save.error as Error).message}</p>}
      {done && <p className="wf-ok" role="status">PIN gespeichert — du kannst jetzt am Terminal stempeln.</p>}

      <button type="button" className="wf-btn wf-btn--primary" disabled={!valid || save.isPending} onClick={() => save.mutate()}>
        PIN speichern
      </button>
    </section>
  )
}
